import { Link } from "react-router-dom";
import "./footer.scss";

function Footer() {
    return (
        <footer>
            <div className="footer__inner">
                <div className="footer-links">
                    <a className="footer-link" href="https://instagram.com/beoneroman">Instagram</a>
                    <a className="footer-link" href="https://www.behance.net/r404man">Behance</a>
                    <a className="footer-link" href="https://github.com/r404man">Github</a>
                    <a className="footer-link" href="linkedin.com/in/oneroman/">Linked</a>
                </div>
                <Link to={"/"} className="footer-logo">
                    <h2>oneroman</h2>
                </Link>
                <div className="footer-copy">
                    Created by <span>Roman Tyrtychko</span> 2022
                </div>
            </div>
        </footer>
    )
}

export default Footer